import { useEntityContext } from './context';

export const useEntity = () => {
  return useEntityContext();
};
